import { GcoopSessionConfig } from '../../types/state.types';
import { getSessionConfig, setSession, setSessionConfig } from '../../utils/session-helper';
import { StoreAction } from '../reduxTypes';
import * as actions from './actions';

const session = getSessionConfig();

const initialState: GcoopSessionConfig = {
  loading: false,
  ...session,
}

const  reducer = (
  state: GcoopSessionConfig = initialState,
  action: StoreAction,
): GcoopSessionConfig => {
  switch (action.type) {
    case actions.SESSION__START_LOADING:
      return { ...state, loading: true };
    case actions.SESSION__STOP_LOADING:
      return { ...state, loading: false };
    case actions.SESSION__SET_SESSION_CONFIGS:
      const newConfigs = { loading: false, ...action.payload };
      setSessionConfig(newConfigs)
      
      return newConfigs;
    case actions.SESSION__UPDATE_SESSION:
      setSession({ userData: action.payload, logged: true })
      return state;

    default:
      return state;
  }
}

export default reducer;
